import PropTypes from 'prop-types';
import React from 'react';
import FieldHelperText from '~components/field-helper-text';
import MonthPickerInput from './month-picker-input';

const FormControlMonthPickerInput = React.forwardRef((props, ref) => {
  const {
    error,
    placeholder,
    InputProps,
    style,
    className,
    FieldHelperTextProps,
    ...otherProps
  } = props;

  return (
    <div style={style} className={className} ref={ref}>
      <MonthPickerInput
        InputProps={{ error: !!error, placeholder, ...InputProps }}
        {...otherProps}
      />
      <FieldHelperText {...FieldHelperTextProps}>{error}</FieldHelperText>
    </div>
  );
});

FormControlMonthPickerInput.propTypes = {
  placeholder: PropTypes.string,
  error: PropTypes.string,
  // props applied to Input
  InputProps: PropTypes.object,
  FieldHelperTextProps: PropTypes.object,
  className: PropTypes.string,
  style: PropTypes.object,
  // otherProps will be applied to MonthPickerInput
};

FormControlMonthPickerInput.defaultProps = {
  error: '',
  placeholder: undefined,
  InputProps: {},
  FieldHelperTextProps: {},
  className: undefined,
  style: {},
};

export default FormControlMonthPickerInput;
